<div
  class="rdc-parking-shelf"
  [class.rdc-parking-shelf--has-event]="parkedEvents().length > 0"
  [class.rdc-parking-shelf--drag-over]="isDragOver()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  @if (parkedEvents().length > 0) {
    @for (parked of parkedEvents(); track parked.event.id) {
      <div
        class="rdc-parked-card"
        draggable="true"
        (dragstart)="onCardDragStart($event, parked)"
        [matTooltip]="parked.event.title"
      >
        <mat-icon aria-hidden="true">drag_indicator</mat-icon>
        <span class="rdc-parked-card-title">{{ parked.event.title }}</span>
        <button
          mat-icon-button
          type="button"
          class="rdc-parked-card-remove"
          matTooltip="Rimuovi dal parcheggio"
          [attr.aria-label]="'Rimuovi ' + parked.event.title + ' dal parcheggio'"
          (click)="removeParked.emit(parked.event.id)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  } @else {
    <mat-icon aria-hidden="true">move_down</mat-icon>
    <span>Trascina qui un evento per parcheggiarlo e spostarlo di giorno</span>
  }
</div>
